import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
/**
 * /access/:token — validates a setter's permanent access token and
 * auto-logs them in. Used in personalized URLs like:
 *   https://app.growthly.com/access/grw_xxxxxxxx
 */
export function AccessToken() {
  const {
    token
  } = useParams<{
    token: string;
  }>();
  const navigate = useNavigate();
  const {
    loginWithAccessToken
  } = useAuth();
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!token) {
      setError('Token no proporcionado');
      return;
    }
    if (!token.startsWith('grw_')) {
      setError('Formato de token inválido');
      return;
    }
    ;
    (async () => {
      try {
        await loginWithAccessToken(token);
        // On real Supabase, signInWithAccessToken navigates via window.location.
        // In mock mode, fall through and navigate manually.
        navigate('/app/dashboard', {
          replace: true
        });
      } catch (err: any) {
        setError(err?.message || 'No pudimos validar tu token. Solicita uno nuevo a tu supervisor.');
      }
    })();
  }, [token, loginWithAccessToken, navigate]);
  return <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center p-4" data-id="element-592">
      <div className="w-full max-w-[480px] bg-white/[0.02] border border-white/5 rounded-[12px] p-8 text-center" data-id="element-593">
        {error ? <>
            <div className="w-12 h-12 rounded-full bg-[#D64545]/10 flex items-center justify-center mx-auto mb-4" data-id="element-594">
              <svg className="w-6 h-6 text-[#D64545]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-595">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-596" />
              </svg>
            </div>
            <h2 className="text-[20px] font-semibold text-white mb-2" data-id="element-597">
              Acceso denegado
            </h2>
            <p className="text-[14px] text-[#9E9E9E] mb-6" data-id="element-598">{error}</p>
            <button onClick={() => navigate('/login')} className="h-11 px-6 bg-white text-[#0B0B0B] font-medium rounded-lg hover:bg-gray-100 transition-colors" data-id="element-599">
              Ir a login
            </button>
          </> : <>
            <div className="w-10 h-10 border-2 border-white/10 border-t-white rounded-full animate-spin mx-auto mb-4" data-id="element-600" />
            <h2 className="text-[18px] font-semibold text-white mb-2" data-id="element-601">
              Validando acceso…
            </h2>
            <p className="text-[13px] text-[#9E9E9E]" data-id="element-602">
              Te llevamos a tu panel en un momento.
            </p>
          </>}
      </div>
    </div>;
}